import React from 'react';
import { buildClassString } from '../StringUtils';
import './style/index.scss';
const DEFAULT_ANIMATION_DELAY_MS = 100;
const ON_OPEN_CLOSE_FINISH_DELAY_MS = 100;
export class SharedSlideout extends React.Component {
    constructor(props) {
        super(props);
        this.closeSlideout = this.closeSlideout.bind(this);
        this.handleTransitionEnd = this.handleTransitionEnd.bind(this);
        this.state = {
            readyToAnimate: false,
            isMounted: false
        };
    }
    componentDidMount() {
        this.setState({ isMounted: true });
        if (this.props.isOpen) {
            this.triggerAnimation();
        }
        if (this.slideoutRef) {
            this.slideoutRef.addEventListener('transitionend', this.handleTransitionEnd);
        }
    }
    componentDidUpdate(nextProps) {
        if (this.props.isOpen !== nextProps.isOpen) {
            this.triggerAnimation();
        }
    }
    triggerAnimation() {
        const { animationDelayMs } = this.props;
        setTimeout(() => {
            this.setState({
                readyToAnimate: !this.state.readyToAnimate
            });
        }, animationDelayMs || DEFAULT_ANIMATION_DELAY_MS);
    }
    handleTransitionEnd(evt) {
        if (evt.propertyName !== 'transform') {
            return;
        }
        if (evt.target !== evt.currentTarget) {
            return;
        }
        const { isOpen, onCloseFinish, onOpenFinish } = this.props;
        if (isOpen && onOpenFinish) {
            setTimeout(onOpenFinish, ON_OPEN_CLOSE_FINISH_DELAY_MS);
        }
        else if (!isOpen && onCloseFinish) {
            setTimeout(onCloseFinish, ON_OPEN_CLOSE_FINISH_DELAY_MS);
        }
    }
    render() {
        const { children, className, isOpen, panelClassName, useCloseButton } = this.props;
        const { readyToAnimate, isMounted } = this.state;
        const slideoutClassName = buildClassString({
            [className]: !!className,
            'shared-slideout': true,
            'shared-slideout--toggled': isOpen && readyToAnimate && isMounted
        });
        return (React.createElement("div", { className: slideoutClassName, ref: ref => this.slideoutRef = ref },
            React.createElement("div", { className: "shared-slideout__overlay", onClick: this.closeSlideout }),
            React.createElement("div", { className: `shared-slideout__panel ${(panelClassName !== null && panelClassName !== void 0 ? panelClassName : '')}` },
                useCloseButton &&
                    React.createElement("div", { className: "shared-slideout__close-button", onClick: this.closeSlideout },
                        React.createElement("i", { className: "icon-cancel" })),
                children)));
    }
    closeSlideout() {
        const { handleCloseSlideout, isOpen } = this.props;
        if (isOpen) {
            handleCloseSlideout();
        }
    }
}
export default { SharedSlideout };
